import React from 'react'
import PropTypes from 'prop-types'

const Divider = ({ label, testId }) => (
  <div
    data-testid={testId}
    className="divider"
  >
    <hr />
    {label && <label>{label}</label>}
  </div>
)

Divider.propTypes = {
  label: PropTypes.string,
  testId: PropTypes.string,
}

export default Divider
